// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  AllBanksPerformanceResponse,
  AllBanksPerformanceResponseT,
  verifyAllBanksPerformanceResponse,
} from "./all-banks-performance-response";

export class AllBanksPerformanceResponses implements flatbuffers.IUnpackableObject<AllBanksPerformanceResponsesT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): AllBanksPerformanceResponses {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsAllBanksPerformanceResponses(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksPerformanceResponses,
  ): AllBanksPerformanceResponses {
    return (obj || new AllBanksPerformanceResponses()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsAllBanksPerformanceResponses(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksPerformanceResponses,
  ): AllBanksPerformanceResponses {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new AllBanksPerformanceResponses()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  results(index: number, obj?: AllBanksPerformanceResponse): AllBanksPerformanceResponse | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new AllBanksPerformanceResponse()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  resultsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startAllBanksPerformanceResponses(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addResults(builder: flatbuffers.Builder, resultsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, resultsOffset, 0);
  }

  static createResultsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startResultsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endAllBanksPerformanceResponses(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // results
    return offset;
  }

  static createAllBanksPerformanceResponses(
    builder: flatbuffers.Builder,
    resultsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    AllBanksPerformanceResponses.startAllBanksPerformanceResponses(builder);
    AllBanksPerformanceResponses.addResults(builder, resultsOffset);
    return AllBanksPerformanceResponses.endAllBanksPerformanceResponses(builder);
  }

  unpack(): AllBanksPerformanceResponsesT {
    return new AllBanksPerformanceResponsesT(
      this.bb!.createObjList<AllBanksPerformanceResponse, AllBanksPerformanceResponseT>(
        this.results.bind(this),
        this.resultsLength(),
      ),
    );
  }

  unpackTo(_o: AllBanksPerformanceResponsesT): void {
    _o.results = this.bb!.createObjList<AllBanksPerformanceResponse, AllBanksPerformanceResponseT>(
      this.results.bind(this),
      this.resultsLength(),
    );
  }

  unpackFields(...fields: string[]): AllBanksPerformanceResponsesT {
    const t = new AllBanksPerformanceResponsesT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("results")) {
      t.results = this.bb!.createObjList<AllBanksPerformanceResponse, AllBanksPerformanceResponseT>(
        this.results.bind(this),
        this.resultsLength(),
      );
    }
    return t;
  }
}

export class AllBanksPerformanceResponsesT implements flatbuffers.IGeneratedObject {
  constructor(public results: AllBanksPerformanceResponseT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.results === null || this.results === undefined) {
      throw new Error('Required field "results" is not set');
    }
    const results = AllBanksPerformanceResponses.createResultsVector(
      builder,
      builder.createObjectOffsetList(this.results),
    );

    return AllBanksPerformanceResponses.createAllBanksPerformanceResponses(builder, results);
  }

  clone(): AllBanksPerformanceResponsesT {
    const obj = new AllBanksPerformanceResponsesT();
    obj.results = this.results.map((e) => e.clone());
    return obj;
  }

  equals(other: AllBanksPerformanceResponsesT): boolean {
    if (this.results.length !== other.results.length) return false;
    for (let i = 0; i < this.results.length; i++) {
      const a = this.results[i];
      const b = other.results[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyAllBanksPerformanceResponses(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyAllBanksPerformanceResponse);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "results");
  } finally {
    verifier.popDepth();
  }
}
